module.exports = __webpack_public_path__ + "static/media/shop.46f3402c.svg";